import type { VADStatus, VADStatusReason } from '../types/vad-state';

/**
 * VAD 상태 관리 설정
 */

export const DEFAULT_VAD_STATUS: VADStatus = 'paused';

export const VAD_PRIORITY_ORDER: VADStatusReason[] = [
  'consent_required',      // 최고 우선순위: 동의 필요
  'audio_playing',         // 실제 TTS 오디오 재생 중
  'speaking',             // 아바타 speaking 중 (TTS 재생 중)
  'loading_response',      // 응답 로딩 중
  'chat_mode',            // 채팅 모드
  'mic_disabled',         // 마이크 비활성화
  'voice_ready',          // 음성 모드 준비 완료 (listening)
];

export const VAD_STATUS_MAP: Record<VADStatusReason, VADStatus> = {
  consent_required: 'paused',
  audio_playing: 'paused',
  speaking: 'paused',
  loading_response: 'paused',
  chat_mode: 'paused',
  mic_disabled: 'paused',
  voice_ready: 'listening',
};

export const VAD_BEHAVIOR_CONFIG = {
  // 로깅 활성화
  ENABLE_LOGGING: true,

  // 상태 변경 디바운싱 (ms)
  STATE_CHANGE_DEBOUNCE: 100,

  // 디버그 정보 저장
  SAVE_DEBUG_INFO: true,
} as const;

export const VAD_STATUS_DESCRIPTIONS: Record<VADStatusReason, string> = {
  consent_required: '동의 모달 표시 중',
  audio_playing: '실제 TTS 오디오 재생 중',
  speaking: '아바타 speaking 중',
  loading_response: '응답 로딩 중',
  chat_mode: '채팅 모드 활성',
  mic_disabled: '마이크 비활성화됨',
  voice_ready: '음성 모드 준비 완료',
};
